module.exports = __webpack_public_path__ + "static/media/Instagram-Icon--inverse.b9e59ba7.svg";